import React, { type ReactNode } from 'react';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type {
	PageConfigContainerProps,
	PageConfigContainer as PageConfigContainerType,
} from './PageConfigContainer.tsx';

const LazyAssetsPageConfigContainer: LazyComponent<
	({ children }: PageConfigContainerProps) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PageConfigContainerType>(
		() =>
			import(
				/* webpackChunkName: "async-assets-page-config-container" */ './PageConfigContainer.tsx'
			).then((module) => module.PageConfigContainer),
		{ ssr: false },
	);

export const AssetsPageConfigContainer = ({
	children,
}: {
	children: ReactNode;
}): React.JSX.Element => (
	<Placeholder name="assets-page-config-container-async">
		<LazyAssetsPageConfigContainer>{children}</LazyAssetsPageConfigContainer>
	</Placeholder>
);
